import { useState } from "react";
import { Flex, Text, Button, ScrollArea, ActionIcon, Modal, Stack, Box, Center } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

const AttributeGroup = ({ label, count, attributes, badgeColor, badgeIcon }) => {
  const [modalOpened, setModalOpened] = useState(false);

  return (
    <>
      {/* Contenedor principal */}
      <Flex
        justify="space-between"
        align="center"
        style={{
          width: "100%", // Ocupa todo el ancho posible
          padding: "5px 5px 5px 10px",
          borderRadius: "50px",
          border: "1px solid rgb(195, 195, 195)",
          whiteSpace: "nowrap", // Evita el wrap
        }}
      >
        <Text size="sm">
          {label} : <b>{count}</b>
        </Text>
        <ActionIcon radius="lg" onClick={() => setModalOpened(true)}>
          <IconInfoCircle size={18} />
        </ActionIcon>
      </Flex>

      {/* Modal para mostrar el listado completo */}
      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={<Text fw={600} size="lg">{`${label} (${count})`}</Text>}
        size="lg"
        radius="md"
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 2,
        }}
      >
        {attributes?.length > 0 ? (
          <Stack spacing="xs">
            {attributes.map((attribute, index) => (
              <Box key={index} style={{
                border: "1px solid rgb(195, 195, 195)", // Borde gris
                borderRadius: "10px", // Forma de cápsula
                padding: "5px 10px", // Espaciado interno
                backgroundColor: "rgb(248, 248, 248)", // Fondo claro opcional
              }}>
                <Center inline>
                  <Box mr={15}>
                    {badgeIcon}
                  </Box>
                  <Box>
                    <Text fw={500}>
                      {attribute.titulo}
                    </Text>
                    <Text size="sm">
                      {attribute?.descripcion}
                    </Text>
                  </Box>
                </Center>
              </Box>
            ))}
          </Stack>
        ) : (
          <Text size="md" c="dimmed">
            No hay atributos disponibles
          </Text>
        )}
      </Modal>
    </>
  );
};

export default AttributeGroup;